import React, { useEffect } from 'react'
import PageBody from '../../components/pagebody/PageBody'
import { Navigate, Route, Routes } from 'react-router-dom'
import JoinBoiReportingWaitlist from './joinboireportingwaitlist/JoinBoiReportingWaitlist'
import ManageBOI from './ManageBoi'
import FileBoi from './fileboi/FileBoi'
import { MANAGE_BOI_ROUTES } from '../constants/constants'
import { useSelector } from 'react-redux'
import { componentKey as authenticationComponentKey } from '../authentication/AuthenticationSlice'
import useTxNavigate from '../../../libs/txnavigate/TxNavigateHook'

function BoiReportingSection() {

    const {signedInUser} = useSelector(state => state[authenticationComponentKey])
    const navigate = useTxNavigate();

    useEffect(() => {
        if(signedInUser?.IsDisableBoi){
            navigate('/')
        }
    }, [])

    return (
        <PageBody>
            <Routes>
                <Route path="/join" element={<JoinBoiReportingWaitlist />} />
                <Route path={`/${MANAGE_BOI_ROUTES.FILE_BOI}`} element={<FileBoi />} />
                <Route exact path="/" element={<ManageBOI />} />
                <Route path={'/*'} element={<Navigate to={`/${MANAGE_BOI_ROUTES.BOI_REPORTING}/`} replace={true} />} />
            </Routes>
        </PageBody>
    )
}

export default BoiReportingSection